import URLConfig from '@Config/urls/url.config';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { Link, Outlet } from 'react-router-dom';

export default function Parameters() {
  const tablinkStyle = { borderBottom: '2px solid lightblue', padding: '5px' }
  return (
    <>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
          Parametres
        </CC.Text>
        <CC.Stack direction="row" gap={2} flexWrap={'wrap'}>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.COUNTRY}
            >
              Pays
            </Link>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.CITY}
            >
              Ville
            </Link>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.COMPANY_TYPE}
            >
              Type Compagnie
            </Link>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.DOCUMENT_TYPE}
            >
              Type Document
            </Link>

            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.CARD_OBJECTION_REASON}
            >
              Motif Opposition Carte
            </Link>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.BIN_OBJECTION_REASON}
            >
              Motif Opposition BIN
            </Link>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.ADDRESS_TYPE}
            >
              Type Adresse
            </Link>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.VACANCY_TYPE}
            >
              Type Vacance
            </Link>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.TITLE}
            >
              Titre
            </Link>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.PROFESSIONAL_POSITION}
            >
              Position Professionnelle
            </Link>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.DELIVERY_OPERATOR}
            >
              Operateur Livraison
            </Link>

            
        </CC.Stack>

        <CC.Box pt="10">
          <Outlet />
        </CC.Box>
      </CC.Box>
    </>
  );
}
